import React from "react";
import { Button } from "../ui/button";
import { Target, Zap, TrendingUp, Settings } from "lucide-react";

const SystemOverview = () => {
  const features = [
    {
      icon: Target,
      title: "Attract the Right Leads:",
      description: "Targeted ads find buyers and sellers most likely to work with you."
    },
    {
      icon: Zap,
      title: "Engage Instantly:",
      description: "Automated responses via SMS, email, and phone keep prospects warm 24/7."
    },
    {
      icon: TrendingUp,
      title: "Convert More Deals:",
      description: "Custom sales funnels and nurturing workflows guide leads to booking viewings and making offers."
    },
    {
      icon: Settings,
      title: "Track & Optimize:",
      description: "Real-time analytics show exactly what's working so you can scale your success."
    }
  ];

  const handleGetStarted = () => {
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Image */}
          <div className="relative">
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg p-2 border border-gray-700">
              <img 
                src="https://customer-assets.emergentagent.com/job_944c48ee-4bbe-46a0-a183-10e223961614/artifacts/9ylmzn6x_ChatGPT%20Image%20Sep%2024%2C%202025%2C%2010_55_04%20PM.png"
                alt="Real Estate Sales Analytics Dashboard"
                className="w-full h-auto rounded-lg object-cover"
              />
            </div>
          </div>

          {/* Right Side - Content */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Your Complete{" "}
              <span className="text-transparent bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text">
                Marketing System
              </span>
              {" "}— Built for Real Estate Sales
            </h2>

            <p className="text-gray-300 text-lg mb-8 leading-relaxed">
              From attracting new leads to closing deals, we use smart technology to optimize the entire marketing process so you can focus on selling properties.
            </p>

            {/* Features List */}
            <div className="space-y-6 mb-8">
              {features.map((feature, index) => {
                const IconComponent = feature.icon;
                return (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <IconComponent className="w-5 h-5 text-black" />
                    </div>
                    <div>
                      <h4 className="text-white font-semibold mb-1">{feature.title}</h4>
                      <p className="text-gray-400">{feature.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* CTA Button */}
            <Button
              onClick={handleGetStarted}
              className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-8 py-3 text-lg transition-all duration-300 transform hover:scale-105"
            >
              Get Started Now
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SystemOverview;